import { create } from "zustand";

export const useDownloadStore = create((set) => ({
    activeDownloads: [],

    addDownload: (file) =>
        set((state) => ({
            activeDownloads: [...state.activeDownloads, file],
        })),

    updateProgress: (id, progress) =>
        set((state) => ({
            activeDownloads: state.activeDownloads.map((f) =>
                f.id === id ? { ...f, progress } : f
            ),
        })),

    markDone: (id) =>
        set((state) => ({
            activeDownloads: state.activeDownloads.map((f) =>
                f.id === id ? { ...f, done: true } : f
            ),
        })),

    removeDownload: (id) =>
        set((state) => ({
            activeDownloads: state.activeDownloads.filter((f) => f.id !== id),
        })),
}));
